import Amplify, { API } from 'aws-amplify';
import moment from 'moment';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router';

import AppSelector from './AppSelector';
import awsconfig from './aws-exports';
import { currentAppEnvironment, EnvironmentBadge } from './components/EnvironmentBadge';
import { startServiceWorkerUpdateChecks } from './serviceWorker';
import { prefixTitle } from './utils/appEnvironment';
import { FeatureFlagProvider } from './utils/featureFlags/FeatureFlagsContext';
import { installImpersonationReadOnlyGuard } from './utils/Impersonation/readOnlyGuard';
import WithAuthenticatedUser from './wrappers/WithAuthenticatedUser';
import WithStore from './wrappers/WithStore';

import './Bootstrap.sass';

Amplify.configure(awsconfig);
API.configure(awsconfig);
installImpersonationReadOnlyGuard();
startServiceWorkerUpdateChecks();
// (#3227) Výchozí název záložky z index.html dostane předponu prostředí ještě před prvním useTitle.
document.title = prefixTitle(document.title, currentAppEnvironment);

// A deploy replaced the old build's lazy chunks: load the new build instead of crashing.
// At most one reload per 10 s, so a chunk that is really missing falls through to the error page.
const CHUNK_RELOAD_KEY = 'alol_chunk_reload';
globalThis.addEventListener('vite:preloadError', (event) => {
    try {
        const lastReload = Number(globalThis.sessionStorage.getItem(CHUNK_RELOAD_KEY) || 0);
        if (Date.now() - lastReload > 10_000) {
            event.preventDefault();
            globalThis.sessionStorage.setItem(CHUNK_RELOAD_KEY, String(Date.now()));
            globalThis.location.reload();
        }
    } catch {
        // no session storage: without the loop guard, keep the default error behaviour
    }
});

moment.updateLocale('en', {
    week: {
        dow: 1, // Set the First day of week to Monday
    },
});

(ReactDOM as any).createRoot(document.getElementById('root')).render(
    <React.StrictMode>
        <EnvironmentBadge />
        <BrowserRouter>
            <WithStore>
                <WithAuthenticatedUser>
                    <FeatureFlagProvider>
                        <AppSelector />
                    </FeatureFlagProvider>
                </WithAuthenticatedUser>
            </WithStore>
        </BrowserRouter>
    </React.StrictMode>
);
export { parsePerformanceProfileJson } from './Admin/Scheduling/model/PerformanceProfileTypes';
export { PERF_PROFILE_STRING_KEYS } from './Admin/Scheduling/model/PerformanceProfileTypes';
